import { MaybePartnerIntegrationUser } from '@dixa/lib-integrations-partner-widgets';
import { User } from 'lib-shared-types-api';

/**
 * Maps Agent/User type to the PartnerIntegrationUser contract type. We
 * explicitly map to the contract type to control which parts of the user/agent
 * context are passed down to partner widgets and to decouple from
 * implementation details.
 *
 * @param user The User/Agent to convert.
 * @returns A PartnerIntegrationUser with the mapped properties of the user
 *   passed in.
 */
export const asPartnerIntegrationUser = (
  user: User | null | undefined,
): MaybePartnerIntegrationUser =>
  user
    ? {
        givenName: user.given_name,
        familyName: user.family_name,
        name: user.name,
        displayName: user.name,
        avatarUrl: user.avatar_url,
        phoneNumber: user.phone_number,
        email: user.email,
        defaultOutboundNumber: user.default_outbound_number,
      }
    : undefined;

export const partnerIntegrationNotificationTimeout = 5000;
